import React from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import SvgHilbiLogoWhite from '@assets/svg/hilbi-logo-white.svg';
import useEnvService from '@hooks/app/useEnvService';
import BannerSC from './feed-banner.styled';

const Banner: React.FC = () => {
  const { formatMessage } = useIntl();
  const history = useHistory();
  const [env] = useEnvService();

  const handleButtonClick = () => {
    history.push(`/communication/${env.xmpp.hilbiId}`);
  };

  return (
    <BannerSC>
      {/* <FeedIcon>
        <img src={SvgAdIcon} width="24" height="17" alt="ad-icon" />
      </FeedIcon> */}
      {/*<img src={svgHilbiLogoHorizontal} alt="hilbi_logo" />*/}
      <span className="banner-heading">{formatMessage({ id: 'home.banner_heading' })}</span>
      <span className="banner-subheading">{formatMessage({ id: 'home.banner_subheading' })}</span>
      <button type="button" onClick={handleButtonClick}>
        {formatMessage({ id: 'home.banner_btn_text' })}
      </button>
      <img src={SvgHilbiLogoWhite} alt="white_hilbi_logo" />
    </BannerSC>
  );
};

export default React.memo(Banner);
